import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DoubleService } from './double-service';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class NominatimService extends DoubleService {
  

  baseUrl: string = environment.BASE_NOMINATIM_URL ?? 'https://nominatim.openstreetmap.org';
  viewBox: string = environment.DEFAULT_VIEW_BOX ?? 'viewbox=-25.0000%2C70.0000%2C50.0000%2C40.0000';
  address: any;
  constructor(
    private http: HttpClient,
    protected override authService: MareAuthService,
    protected override tokenService: TokenService,
    protected override injector: Injector
  
  ) { super(authService, tokenService, injector ); }
  
  
  getNominatim() {
    return this.platformApiWpService.getRequest('msc/v1/nominatim/get', null, false, true);
  }

  
  addressLookup(address:Address): Observable<NominatimResponse[]> {
    let req:string = '';
    if(!address.street){
      console.error("Indirizzo obbligatorio");
      return of([]);
    }
    req += 'street='+address.street;
    if(address.city){
      req +="&city="+address.city;
    }
    if(address.county){
      req += "&county="+address.county;
    }
    if(address.country){
      req+='&country='+address.country;
    }
    if(address.postalCode){
      req += "&postalcode="+address.postalCode;
    }
    let url = `${this.baseUrl}/search?format=json&${req}&${this.viewBox}&bounded=1`;
    return this.http.get(url).pipe(
      map((res: any) => {
        return res.map((item: any) => new NominatimResponse(item.lat, item.lon, item.display_name));
      })
    );
  }

  buildAddress(addStreet: string, addCity: string, addHouseNumber: string, addProvince: string, addPostalCode: string, addCountry: string) {
    let streetOnly;

    if (addStreet.indexOf('-') > -1) {
      streetOnly = addStreet.split('-')[0].trim();
    } else {
      streetOnly = addStreet;
    }
    const street = addStreet ? streetOnly.replace(/\s/g, "+") : '';
    const city = addCity ? addCity.replace(/\s/g, "+") : '';
    // const houseNumber = addHouseNumber;
    const postalCode = addPostalCode;
    const province = addProvince ? addProvince.replace(/\s/g, "+") : '';
    const country = addCountry;
    let address: Address = new Address(street, city, province, postalCode, country);
   
    return address;
  }
}

export class Address{

  street : string;
  city : string;
  county: string;
  postalCode: string;
  country?: string;

  constructor(
    street:string, city:string, county:string, postalCode:string, country?:string) {
      this.street = street;
      this.city = city;
      this.county = county;
      this.postalCode = postalCode;
      this.country = country;
     }

}

export class NominatimResponse {
  constructor(
    public latitude: number,
    public longitude: number,
    public displayName: string
  ) { }
}
